import React from "react";
import { Controller } from "react-hook-form";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Alert,
} from "@mui/material";
import { FormattedMessage } from "react-intl";
import { REPORT_CATEGORIES } from "../constants/reportCategories";

export const CategoryStep = ({ control, errors }) => {
  return (
    <FormControl component="fieldset" fullWidth>
      <Controller
        name="category"
        control={control}
        rules={{ required: "general.please-choose-category" }}
        render={({ field }) => (
          <RadioGroup
            {...field}
            aria-label="report-category"
          >
            {REPORT_CATEGORIES.map((category) => (
              <FormControlLabel
                key={category.id}
                value={category.id}
                control={<Radio />}
                label={
                  <FormattedMessage
                    id={`abuse-report.category.${category.id}`}
                    defaultMessage={category.name}
                  />
                }
              />
            ))}
          </RadioGroup>
        )}
      />
      {errors.category && (
        <Alert severity="error" sx={{ mt: 1 }}>
          <FormattedMessage id={errors.category.message} defaultMessage={errors.category.message} />
        </Alert>
      )}
    </FormControl>
  );
};
